import { SortingState } from '@tanstack/react-table';
import { useQuery } from 'react-query';
import { network } from 'services/network';
import { NarrativeRequest } from 'utilitys/narrative/narrativeTools';

import { QueryKeys } from 'api/queryKeys';

import { FilterNames } from 'components/common/GlobalFilterComponent/GlobalFilterComponent.utils';
import { Pagination } from 'components/common/pagination/customPagination';

import { IFilter } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { IActivityCompletionList, TKeys } from 'components/widgets/ActivityCompletionPlan/utils/helper';

const queryFn = (params: QueryParams) => {
    return network.post('api/bo/getActivityCompletionPlan', params).then((response) => {
        return response.data;
    });
};
export const useQueryActivityCompletionPlan = (params: QueryParams) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['activityCompletionPlan', params],
        queryFn: () => queryFn(params),
        enabled:
            Boolean(params?.filter?.filters?.find((item) => item.name === FilterNames.FRAGNET_SEARCH)) &&
            Boolean(params.metaDataId),
    });
};

interface QueryParams extends NarrativeRequest {
    contractId: number | null | undefined;
    metaDataId: number | undefined;
    tabId: TKeys;
    filter: {
        filters: IFilter[] | undefined;
    };
    sortingRequestList: SortingState;
    paging: Pagination;
}

export interface QueryResponse {
    activity_completion_list: IActivityCompletionList[];
    tabId: TKeys;
    info: IToolTip;
    planned_finish_date: number;
    planned_finish_date_change: number | null;
    baseline_finish_date: number;
    criticality_schedule_adherence: {
        actualPercent: number;
        plannedPercent: number;
        scheduleAdherence: number;
    };
    completion_schedule_adherence: {
        actualPercent: number;
        plannedPercent: number;
        scheduleAdherence: number;
    };
    delaying_predecessors: number;
    blocking_predecessors: number;
    allCount: number;
    blokersCount: number;
    delaydCount: number;
    onScheduleCount: number;
    completedCount: number;
    numOfPages: number;
}
